import React from 'react'

import { useIntl } from 'react-intl'
import DeleteIcon from '@mui/icons-material/Delete'
import { TableColumn } from 'react-data-table-component'

import Badge from '../../../../../components/Badge'
import { IconButton } from '../../../../../components/Button'
import type { UserGroupScopeItem } from './ModalUserGroupsAccess'
import DataTable from '../../../../../components/DataTable/DataTable'
import ModalUserGroupsAccessNameCell from './ModalUserGroupsAccessNameCell'
import ModalUserGroupsAccessListEmptyState from './ModalUserGroupsAccessListEmptyState'

type ModalUserGroupsAccessListProps = {
	isSubmitting?: boolean
	loading?: boolean
	accessItems?: UserGroupScopeItem[]
	onDeleteItem?: (itemId: string) => void
}

const ModalUserGroupsAccessList = ({
	isSubmitting = false,
	loading = false,
	accessItems = [],
	onDeleteItem,
}: ModalUserGroupsAccessListProps) => {
	const { formatMessage } = useIntl()

	const hasData = !!accessItems.length

	const typeConfig = {
		Branch: {
			label: formatMessage({ id: 'entity_type.branch' }),
			color: 'info' as const,
		},
		User: {
			label: formatMessage({ id: 'entity_type.user' }),
			color: 'warning' as const,
		},
	}

	const handleDeleteClick = (itemId: string) => {
		if (onDeleteItem) onDeleteItem(itemId)
	}

	const columns: TableColumn<UserGroupScopeItem>[] = [
		{
			name: formatMessage({ id: 'user_groups.access_target' }),
			selector: (row) => row.label,
			cell: (row) => <ModalUserGroupsAccessNameCell row={row} />,
			sortable: true,
		},
		{
			name: formatMessage({ id: 'global.type' }),
			selector: (row) => row.type,
			cell: (row) => (
				<Badge
					label={typeConfig[row.type].label}
					color={typeConfig[row.type].color}
				/>
			),
			sortable: true,
		},
		{
			name: '',
			cell: (row) => (
				<IconButton
					title={formatMessage({ id: 'global.delete' })}
					size="small"
					color="error"
					onClick={() => handleDeleteClick(row.id)}
					disabled={isSubmitting}
				>
					<DeleteIcon />
				</IconButton>
			),
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
		},
	]

	if (!hasData) return <ModalUserGroupsAccessListEmptyState />

	return (
		<DataTable
			keyField="id"
			data={accessItems}
			columns={columns}
			pagination={false}
			progressPending={loading}
		/>
	)
}

export default ModalUserGroupsAccessList
